import "dayjs/locale/en";
import "dayjs/locale/nb";
import { MonthView as MantineMonthView, MonthViewProps } from "@mantine/schedule";
import styles from "./styles.module.css";
import { useTranslation } from "react-i18next";

export const MonthView = (props: MonthViewProps) => {
  const { i18n, t } = useTranslation();
  const currentLanguage = i18n.language;

  return (
    <MantineMonthView
      {...props}
      radius={0}
      locale={currentLanguage.startsWith("no") ? "nb" : "en"}
      withHeader={false}
      classNames={{
        monthView: styles.root,
        monthViewWeekday: styles.weekday,
        monthViewDay: styles.day,
        monthViewWeekdays: styles.weekdays,
        monthViewWeek: styles.week,
        monthViewDayLabel: styles.dayLabel,
        ...props.classNames,
      }}
      labels={{
        ...props.labels,
      }}
    />
  );
};

export default MonthView;
